var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0.6 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    className: "st0",
    d: "M0.6,1.8h1.8V1.2C2.4,0.5,2.9,0,3.6,0c0,0,0,0,0,0h3.6c0.7,0,1.2,0.5,1.2,1.2v0.6h1.8 c0.3,0,0.6,0.3,0.6,0.6S10.5,3,10.2,3c0,0,0,0,0,0H9.6v7.8c0,0.7-0.5,1.2-1.2,1.2h-6c-0.7,0-1.2-0.5-1.2-1.2V3H0.6 C0.3,3,0,2.7,0,2.4C0,2.1,0.3,1.8,0.6,1.8z M2.4,3v7.8h6V3H2.4z M3.6,1.8h3.6V1.2H3.6V1.8z M3.6,4.2h1.2v5.4H3.6V4.2z M6,4.2h1.2 v5.4H6V4.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletewhite);
export default __webpack_public_path__ + "static/media/deletewhite.9a7088b11ac78cb7f70845edbe6d78b8.svg";
export { ForwardRef as ReactComponent };